import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useTranslations } from '../context/TranslationContext';

interface PublicationProps {
  year: string;
  title: string;
  journal: string;
  link: string;
  description?: string; // Add optional description prop
}

const Publication: React.FC<PublicationProps> = ({ year, title, journal, link, description }) => {
  const { t } = useTranslations();
  return (
    <div
      className="glass-panel rounded-2xl transition-all duration-300 p-6 md:p-8 flex flex-col group cursor-pointer border border-white/10 hover:border-cosmic-teal/40 hover:shadow-[0_0_30px_rgba(45,212,191,0.12)]"
      onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}
    >
      <div className="flex-grow">
        <span className="inline-block text-sm font-semibold text-nebula-pink mb-4 uppercase tracking-wide">{year}</span>
        <h3 className="text-xl font-bold text-white mb-3 leading-snug">{title}</h3>
        <p className="text-white/80 text-base leading-relaxed mb-3">{journal}</p>
        {description && <p className="text-base leading-relaxed text-white/80">{description}</p>}
      </div>
      <div className="mt-6">
        <button
          onClick={(e) => {
            e.stopPropagation();
            window.open(link, '_blank', 'noopener,noreferrer');
          }}
          className="inline-flex w-full items-center justify-between rounded-xl border border-white/10 bg-gradient-to-r from-cosmic-teal/20 to-transparent px-4 py-3 text-sm font-bold text-white transition-all duration-300 group-hover:border-white/20 group-hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-cosmic-teal focus:ring-offset-2 focus:ring-offset-void-blue"
        >
          <span>{t("view_article")}</span>
          <ExternalLink size={16} aria-hidden="true" className="transition-transform duration-200 group-hover:translate-x-1" />
        </button>
      </div>
    </div>
  );
};

export default Publication;
